import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SelvedgeShadeReferenceService extends BaseReferenceService {
  constructor() {
    super('SelvedgeShadeReference');
  }

  // The unscoped get() describes each shade as "SPEC / KEY - Description"; use this
  // instead wherever the form already knows the selvedge spec.
  getForSelvedgeSpec(selvedgeSpecId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSelvedgeSpec/${selvedgeSpecId}`);
  }
}
